import { render, staticRenderFns } from "./UpdateUserPasswordPage.vue?vue&type=template&id=45443ab6&scoped=true&"
import script from "./UpdateUserPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserPasswordPage.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateUserPasswordPage.vue?vue&type=style&index=0&id=45443ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45443ab6",
  null
  
)

export default component.exports